
export const MenuOptions = [
    { value: "1", label: "Application" },
    { value: "2", label: "Academics" },
    { value: "3", label: "Account" },
    { value: "4", label: "Inventory" },
    { value: "6", label: "Library" },
    { value: "7", label: "HR" },
    { value: "5", label: "Exam" },
    { value: "8", label: "LMS" },
    { value: "9", label: "Infra" },
];

export const BloodGroupOptions = [
    { value: "O-", label: "O-" },
    { value: "O+", label: "O+" },
    { value: "A-", label: "A-" },
    { value: "A+", label: "A+" },
    { value: "B-", label: "B-" },
    { value: "B+", label: "B+" },
    { value: "AB-", label: "AB-" },
    { value: "AB+", label: "AB+" },
];

export const OldStudentOptions = [
    { value: "1", label: "Yes" },
    { value: "2", label: "No" },
];
export const OneTwoWayOptions = [
    { value: "1", label: "One Way" },
    { value: "2", label: "Two Way" },
];
export const DifferentAbleOptions = [
    { value: true, label: "Able" },
    { value: false, label: "Differently-Able" },
];

export const NepalDistrictOptions = [
    { value: "Achham", label: "Achham" },
    { value: "Arghakhanchi", label: "Arghakhanchi" },
    { value: "Baglung", label: "Baglung" },
    { value: "Baitadi", label: "Baitadi" },
    { value: "Bajhang", label: "Bajhang" },
    { value: "Bajura", label: "Bajura" },
    { value: "Banke", label: "Banke" },
    { value: "Bara", label: "Bara" },
    { value: "Bardiya", label: "Bardiya" },
    { value: "Bhaktapur", label: "Bhaktapur" },
    { value: "Bhojpur", label: "Bhojpur" },
    { value: "Chitwan", label: "Chitwan" },
    { value: "Dadeldhura", label: "Dadeldhura" },
    { value: "Dailekh", label: "Dailekh" },
    { value: "Dang", label: "Dang" },
    { value: "Darchula", label: "Darchula" },
    { value: "Dhading", label: "Dhading" },
    { value: "Dhankuta", label: "Dhankuta" },
    { value: "Dhanusa", label: "Dhanusa" },
    { value: "Dolakha", label: "Dolakha" },
    { value: "Dolpa", label: "Dolpa" },
    { value: "Doti", label: "Doti" },
    { value: "Gorkha", label: "Gorkha" },
    { value: "Gulmi", label: "Gulmi" },
    { value: "Humla", label: "Humla" },
    { value: "Ilam", label: "Ilam" },
    { value: "Jajarkot", label: "Jajarkot" },
    { value: "Jhapa", label: "Jhapa" },
    { value: "Jumla", label: "Jumla" },
    { value: "Kailali", label: "Kailali" },
    { value: "Kalikot", label: "Kalikot" },
    { value: "Kanchanpur", label: "Kanchanpur" },
    { value: "Kapilvastu", label: "Kapilvastu" },
    { value: "Kaski", label: "Kaski" },
    { value: "Kathmandu", label: "Kathmandu" },
    { value: "Kavrepalanchok", label: "Kavrepalanchok" },
    { value: "Khotang", label: "Khotang" },
    { value: "Lalitpur", label: "Lalitpur" },
    { value: "Lamjung", label: "Lamjung" },
    { value: "Mahottari", label: "Mahottari" },
    { value: "Makwanpur", label: "Makwanpur" },
    { value: "Manang", label: "Manang" },
    { value: "Morang", label: "Morang" },
    { value: "Mugu", label: "Mugu" },
    { value: "Mustang", label: "Mustang" },
    { value: "Myagdi", label: "Myagdi" },
    { value: "Nawalpur", label: "Nawalpur" },
    { value: "Nuwakot", label: "Nuwakot" },
    { value: "Okhaldhunga", label: "Okhaldhunga" },
    { value: "Palpa", label: "Palpa" },
    { value: "Panchthar", label: "Panchthar" },
    { value: "Parasi", label: "Parasi" },
    { value: "Parbat", label: "Parbat" },
    { value: "Parsa", label: "Parsa" },
    { value: "Pyuthan", label: "Pyuthan" },
    { value: "Ramechhap", label: "Ramechhap" },
    { value: "Rasuwa", label: "Rasuwa" },
    { value: "Rautahat", label: "Rautahat" },
    { value: "Rolpa", label: "Rolpa" },
    { value: "Rukum East", label: "Rukum East" },
    { value: "Rukum West", label: "Rukum West" },
    { value: "Rupandehi", label: "Rupandehi" },
    { value: "Salyan", label: "Salyan" },
    { value: "Sankhuwasabha", label: "Sankhuwasabha" },
    { value: "Saptari", label: "Saptari" },
    { value: "Sarlahi", label: "Sarlahi" },
    { value: "Sindhuli", label: "Sindhuli" },
    { value: "Sindhupalchok", label: "Sindhupalchok" },
    { value: "Siraha", label: "Siraha" },
    { value: "Solukhumbu", label: "Solukhumbu" },
    { value: "Sunsari", label: "Sunsari" },
    { value: "Surkhet", label: "Surkhet" },
    { value: "Tanahun", label: "Tanahun" },
    { value: "Taplejung", label: "Taplejung" },
    { value: "Terhathum", label: "Terhathum" },
    { value: "Udayapur", label: "Udayapur" },
];

export const DifferentAbleTypesOptions = [
    { value: 'क', label: "क" },
    { value: 'ख', label: "ख" },
    { value: 'ग', label: "ग" },
    { value: 'घ', label: "घ" },
    { value: 'ङ', label: "ङ" },
];

export const ReligionsOptions = [
    { value: "Hinduism", label: "Hinduism" },
    { value: "Buddhism", label: "Buddhism" },
    { value: "Christianity", label: "Christianity" },
    { value: "Jainism", label: "Jainism" },
    { value: "Judaism", label: "Judaism" },
    { value: "Sikhism", label: "Sikhism" },
    { value: "Islamic", label: "Islamic" },
    { value: "Kirat", label: "Kirat" },
    { value: "Cristian", label: "Cristian" },
    { value: "Others", label: "Others" },
];

export const OneOrTwoWayOptions = [
    { value: "1", label: "One Way" },
    { value: "2", label: "Two Way" },
];

export const PrintNonPrintOptions = [
    { value: "0", label: "Not Printed" },
    { value: "1", label: "Printed" },
];

export const CardOptions = [
    { value: "1", label: "Character/Transfer" },
    { value: "3", label: "ID Card" },
    { value: "2", label: "Van Card" },
];

export const FurnitureOptions = [
    { value: "1", label: "Furniture" },
    { value: "3", label: "Equipment" },
    { value: "2", label: "Vechicle" },
];

export const HostelTypeOptions = [
    { value: "Girls Hostels", label: "Girls Hostels" },
    { value: "Boys Hostels", label: "Boys Hostels" },
];

export const NoYesOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
];

export const ProgramOptions = (programs) => {
    if (programs && Array.isArray(programs)) {
        return programs?.map((program, index) => ({
            value: program?.programid?.toString(),
            label: program?.programid + ". " + program?.programtitle,
        }));
    } else {
        return [];
    }
};

export const UGCProgramOptions = (programs) => {
    if (programs && Array?.isArray(programs)) {
        return programs?.map((program, index) => ({
            value: program?.id?.toString(),
            label: program?.id + ". " + program?.programName,
            ugc_faculty: program?.facultyId,
            levelId: program?.levelId,
        }));
    } else {
        return [];
    }
};

export const AssignSubjGroupOptions = (sub_grp_list) => {
    if (sub_grp_list && Array?.isArray(sub_grp_list)) {
        return sub_grp_list?.map((item, index) => ({
            value: item?.sn?.toString(),
            label: item?.sn + ". " + item?.grp_name,
        }));
    } else {
        return [];
    }
};

export const UGCBatchOptions = (batchs) => {
    if (batchs && Array?.isArray(batchs)) {
        return batchs?.map((batch, index) => ({
            value: batch?.id?.toString(),
            label: batch?.id + ". " + batch?.batchNepali,
            batch_year: batch?.name,
            batch_year_ne: batch?.batchNepali,
        }));
    } else {
        return [];
    }
};

export const UGCFiscalYearOptions = (fiscals) => {
    if (fiscals && Array?.isArray(fiscals)) {
        return fiscals?.map((fiscal, index) => ({
            value: fiscal?.id?.toString(),
            label: fiscal?.id + ". " + fiscal?.yearNepali,
            yearEnglish: fiscal?.yearEnglish,
            yearNepali: fiscal?.yearNepali,
        }));
    } else {
        return [];
    }
};

export const BuildingOptions = (building) => {
    if (building && Array?.isArray(building)) {
        return building?.map((item, index) => ({
            value: item?.sn?.toString(),
            label: item?.houseName,
            ugc_id: item?.ugc_id
        }));
    } else {
        return [];
    }
};

export const YearListOptions = (yearsList) => {
    if (yearsList && Array?.isArray(yearsList)) {
        return yearsList?.map((yearr, index) => ({
            value: yearr?.sn?.toString(),
            label: yearr?.yearr,
        }));
    } else {
        return [];
    }
};

export const NepYearListOptions = (yearsList) => {
    if (yearsList && Array?.isArray(yearsList)) {
        return yearsList?.map((yearr, index) => ({
            value: yearr?.sn?.toString(),
            label: yearr?.yearr_ne,
        }));
    } else {
        return [];
    }
};

export const OptionalGroupOptions = (items) => {
    if (items && Array.isArray(items)) {
        return items?.map((item, index) => ({
            value: item?.sn?.toString(),
            label: item?.sn + (". ") + item?.optional_grp_name
        }));
    } else {
        return [];
    }
};

export const SubjectCategoryOptions = (items) => {
    if (items && Array.isArray(items)) {
        return items?.map((item, index) => ({
            value: item?.sn?.toString(),
            label: item?.sn + (". ") + item?.subj_cat_name
        }));
    } else {
        return [];
    }
};

export const DestinationOptions = (items) => {
    if (items && Array.isArray(items)) {
        return items?.map((item, index) => ({
            value: item?.sn?.toString(),
            label: item?.sn + (". ") + item?.dest_name
        }));
    } else {
        return [];
    }
};

export const LevelOptions = (levels) => {
    if (levels && Array?.isArray(levels)) {
        return levels?.map((level, index) => ({
            value: level?.levelid?.toString(),
            label: index + 1 + ". " + level?.levelname,
        }));
    } else {
        return [];
    }
};

export const GraduationGenerateOptions = (students) => {
    if (students && Array?.isArray(students)) {
        return students?.map((student, index) => ({
            value: student?.member_sn?.toString(),
            label: `${student?.roll_no}. ${student?.first_name || ""} ${student?.middle_name || ""} ${student?.last_name || ""} | Phone No.: ${student?.phone || ""} | Student ID: ${student.member_sn} | Address: ${student.municipality_name || ""}-${student.wardno || ""}`,
        }));
    } else {
        return [];
    }
};

export const FacultyOptions = (faculties) => {
    if (faculties && Array?.isArray(faculties)) {
        return faculties?.map((faculty, index) => ({
            value: faculty?.facid?.toString(),
            label: index + 1 + ". " + faculty?.facname,
        }));
    } else {
        return [];
    }
};

export const EmpFacultyOptions = (faculties) => {
    if (faculties && Array?.isArray(faculties)) {
        return faculties?.map((faculty, index) => ({
            value: faculty?.facname,
            label: faculty?.facname,
        }));
    } else {
        return [];
    }
};

export const YesNoOptions = (yes_no) => {
    if (yes_no && Array.isArray(yes_no)) {
        return yes_no.map((item, index) => ({
            value: item.value.toString(),
            label: item.label,
        }));
    } else {
        return [];
    }
};

export const ExamTypeOptions = (exam_types) => {
    if (exam_types && Array?.isArray(exam_types)) {
        return exam_types?.map((item, index) => ({
            value: item?.ex_type_id?.toString(),
            label: index + 1 + ". " + item?.ex_type_name,
            fm: item?.ex_type_fm,
            p_fm: item?.ex_mrg_perc,
            pm: item?.ex_type_pm
        }));
    } else {
        return [];
    }
};

export const SubMenuOptions = (sub_menu) => {
    if (sub_menu && Array?.isArray(sub_menu)) {
        return sub_menu?.map((item, index) => ({
            value: item?.sub_m_id?.toString(),
            label: item?.sub_m_id + ". " + item?.name + "(" + item?.name_nep + ")",
        }));
    } else {
        return [];
    }
};

export const DesignationOptions = (dest) => {
    // General Ledger Options
    if (dest && Array?.isArray(dest)) {
        return dest?.map((item, index) => ({
            value: item?.desig_id?.toString(),
            label: item?.desig_name
        }));
    } else {
        return [];
    }
};

export const SubLedgerTypeOptions = (options) => {
    // General Ledger Options
    if (options && Array?.isArray(options)) {
        return options?.map((item, index) => ({
            value: item?.sn?.toString(),
            label: item?.sub_ledger_type_name

        }));
    } else {
        return [];
    }
};

export const BranchOptions = [
    { value: "1", label: "Siddhartha Institute Of Medical Technology Pvt. Ltd." },
];

export const BackRegularOptions = [
    { value: "0", label: "Regular" },
    { value: "1", label: "Back" },
];

export const TechnicalNonTechnicalOptions = [
    { value: true, label: "Technical" },
    { value: false, label: "Non-Technical" },
];

export const ActiveInactiveOptions = (active_inactive_list) => {
    if (active_inactive_list && Array.isArray(active_inactive_list)) {
        return active_inactive_list.map((item, index) => ({
            value: item.value.toString(),
            label: item.label
        }));
    } else {
        return [];
    }
};

export const AcademicsYearOptions = (items) => {
    if (items && Array?.isArray(items)) {
        return items?.map((item, index) => ({
            value: item?.acdmcyearid?.toString(),
            label: index + 1 + ". " + item?.acdmcyear,
        }));
    } else {
        return [];
    }
};

export const MediumOptions = (lanugage_medium) => {
    if (lanugage_medium && Array.isArray(lanugage_medium)) {
        return lanugage_medium.map((item, index) => ({
            value: item.value.toString(),
            label: item.label
        }));
    } else {
        return [];
    }
};

export const SectionOptions = (sections) => {
    if (sections && Array?.isArray(sections)) {
        return sections?.map((sec, index) => ({
            value: sec?.sectionid?.toString(),
            label: index + 1 + ". " + sec?.sectionname,
        }));
    } else {
        return [];
    }
};

export const TeamOptions = (teams) => {
    if (teams && Array?.isArray(teams)) {
        return teams?.map((team, index) => ({
            value: team?.teamid?.toString(),
            label: index + 1 + ". " + team?.teamname,
        }));
    } else {
        return [];
    }
};

export const ShiftsOptions = (shifts) => {
    if (shifts && Array?.isArray(shifts)) {
        return shifts?.map((shift, index) => ({
            value: shift?.shiftid?.toString(),
            label: index + 1 + ". " + shift?.shiftname
        }));
    } else {
        return [];
    }
};

export const YearSemesterOptions = (year_sem) => {
    // General Ledger 
    if (year_sem && Array?.isArray(year_sem)) {
        return year_sem?.map((item, index) => ({
            value: item?.yearsemesterid?.toString(),
            label: index + 1 + ". " + item?.yearsemestername,
        }));
    } else {
        return [];
    }
};

export const MajorSubjectOptions = (major_subject) => {
    // General Ledger Options
    if (major_subject && Array?.isArray(major_subject)) {
        return major_subject?.map((ms_data, index) => ({
            value: ms_data?.sn?.toString(),
            label: ms_data?.sn + ". " + ms_data?.msubjectname,
        }));
    } else {
        return [];
    }
};

export const SubjectOptions = (subjects) => {
    if (subjects && Array?.isArray(subjects)) {
        return subjects?.map((subj, index) => ({
            value: subj?.sn?.toString(),
            label: subj?.sn + ". " + subj?.subj_code + " " + subj?.subj_name,
        }));
    } else {
        return [];
    }
};

export const MarriedOptions = (married_status_list) => {
    if (married_status_list && Array.isArray(married_status_list)) {
        return married_status_list.map((item, index) => ({
            value: item.value.toString(),
            label: item.label
        }));
    } else {
        return [];
    }
};

export const EmployeeOptions = (emps) => {
    if (emps && Array?.isArray(emps)) {
        return emps?.map((emp, index) => ({
            value: emp?.member_sn,
            label: `${emp?.member_sn ? emp?.member_sn : ""}. ${emp?.first_name ? emp?.first_name : ""} ${emp?.middle_name ? emp?.middle_name : ""} ${emp?.last_name ? emp?.last_name : ""}`,
            branch_id: emp?.branch_id,
            emp_sn: emp?.emp_sn,
            designation: emp?.designation,
            grade_amt: emp?.grade_amt|| 0,
            grade_count: emp?.grade_count|| 0,
            initail_salary: emp?.initail_salary|| 0,
            pf_amount: emp?.pf_amount|| 0,
            pf_status: emp?.pf_status,
            pf_thap_perc: emp?.pf_thap_perc || 0,
            ss_tax: emp?.ss_tax|| 0,
            tax_amt: emp?.tax_amt|| 0,
            allowance: emp?.allowance || 0,
            extra_period: emp?.extra_period || 0,
            post_allowance: emp?.post_allowance || 0,
            hit_kosh: emp?.hit_kosh || 0,
            sem_period: emp?.sem_period || 0,
            irre_period: emp?.irre_period || 0,
            insurance: emp?.insurance || 0,
            ss_found: emp?.ss_found || 0,
            holiday_thap: emp?.holiday_thap || 0,
            holiday_katti: emp?.holiday_katti || 0,
        }));
    } else {
        return [];
    }
};

export const TeachersOptions = (emps) => {
    if (emps && Array.isArray(emps)) {
        return emps?.map((emp, index) => ({
            value: emp?.member_sn,
            label: `${emp?.member_sn ? emp?.member_sn : ""}. ${emp?.first_name ? emp?.first_name : ""} ${emp?.middle_name ? emp?.middle_name : ""} ${emp?.last_name ? emp?.last_name : ""} | ${emp?.phone_no} | ${emp?.per_add}`,
        }));
    } else {
        return [];
    }
};

export const GenderOptions = (gender_list) => {

    if (gender_list && Array.isArray(gender_list)) {
        return gender_list.map((item, index) => ({
            value: item.value.toString(),
            label: item.label
        }));
    } else {
        return [];
    }
};

export const MonthOptions = [
    { value: "01", label: "Baishakh" },
    { value: "02", label: "Jestha" },
    { value: "03", label: "Ashadh" },
    { value: "04", label: "Shrawan" },
    { value: "05", label: "Bhadra" },
    { value: "06", label: "Ashwin" },
    { value: "07", label: "Kartik" },
    { value: "08", label: "Mangsir" },
    { value: "09", label: "Poush" },
    { value: "10", label: "Magh" },
    { value: "11", label: "Falgun" },
    { value: "12", label: "Chaitra" },
    { value: "13", label: "Festivals" },

];

export const WardNoOptions = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "13", label: "13" },
    { value: "12", label: "12" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
    { value: "17", label: "17" },
    { value: "18", label: "18" },
    { value: "19", label: "19" },
];

export const EmpLevelOptions = [
    { value: "Primary Level", label: "Primary Level" },
    { value: "+2", label: "+2" },
    { value: "Bachelor", label: "Bachelor" },
    { value: "Master", label: "Master" },
    { value: "MPhil", label: "MPhil" },
    { value: "PhD", label: "PhD." },
];

export const GeneralLedgerTypeOptions = (itels) => {
    if (itels && Array.isArray(itels)) {
        return itels.map((item, index) => ({
            value: item.value.toString(),
            label: item.label
        }));
    } else {
        return [];
    }
};

export const CasteOptions = (castes) => {
    if (castes && Array?.isArray(castes)) {
        return castes?.map((item, index) => ({
            value: item?.caste_id?.toString(),
            label: item?.caste_id + 1 + ". " + item?.caste_name,
        }));
    } else {
        return [];
    }
};

export const UGC_Designation_Options = (castes) => {
    if (castes && Array?.isArray(castes)) {
        return castes?.map((item, index) => ({
            value: item?.id?.toString(),
            label: `${item?.category} | ${item?.type} | ${item?.postName}`,
        }));
    } else {
        return [];
    }
};

export const BoardOptions = (boards) => {
    if (boards && Array?.isArray(boards)) {
        return boards?.map((item, index) => ({
            value: item?.sn?.toString(),
            label: index + 1 + ". " + item?.board_name,
        }));
    } else {
        return [];
    }
};

export const ProvinceOptions = (province) => {
    if (province && Array.isArray(province)) {
        return province.map((item, index) => ({
            value: item?.province_id.toString(),
            label: index + 1 + ". " + item?.province_name,
        }));
    } else {
        return [];
    }
};

export const DistrictOptions = (districtData) => {
    if (districtData && Array?.isArray(districtData)) {
        return districtData?.map((district, index) => ({
            value: district?.district_id?.toString(),
            label: district?.district_id + ". " + district?.district_name,
        }));
    } else {
        return [];
    }
};

export const MunOptions = (munData) => {
    // General Ledger Options
    if (munData && Array?.isArray(munData)) {
        return munData?.map((mun, index) => ({
            value: mun?.id?.toString(),
            label: index + 1 + ". " + mun?.mun_name,
        }));
    } else {
        return [];
    }
};

export const SubCasteOptions = (onSubCasteData) => {
    // General Ledger Options
    if (onSubCasteData && Array?.isArray(onSubCasteData)) {
        return onSubCasteData?.map((sub_caste, index) => ({
            value: sub_caste?.sub_caste_id?.toString(),
            label: `${sub_caste?.sub_caste_id + (". ") + sub_caste?.sub_caste_name}`,
        }));
    } else {
        return [];
    }
};

export const QualificationsOptions = (items) => {
    // General Ledger Options
    if (items && Array?.isArray(items)) {
        return items?.map((item, index) => ({
            value: item?.sn?.toString(),
            label: `${item?.sn + (". ") + item?.qualification_name}`,
        }));
    } else {
        return [];
    }
};

export const TrasactionOptions = (trans) => {
    if (trans && Array.isArray(trans)) {
        return trans.map((item, index) => ({
            value: item.value.toString(),
            label: item.label,
        }));
    } else {
        return [];
    }
};

export const AcGeneralLedgOptions = (ledg_list) => {
    if (ledg_list && Array?.isArray(ledg_list)) {
        return ledg_list?.map((item, index) => ({
            value: item?.glid?.toString(),
            label: index + 1 + ". " + item?.gl_name
        }));
    } else {
        return [];
    }
};

export const SubLedgersOptions = (ledger) => {
    if (ledger && Array.isArray(ledger)) {
        return ledger?.map((ledger, index) => ({
            value: ledger?.sglsn?.toString(),
            label: `${ledger?.sglsn + (". ") + ledger?.sub_ledg_name}`,
            userShow: ledger?.mem_cate_id
        }))
    }
};

export const ParticularOptions = (particulars) => {
    if (particulars && Array?.isArray(particulars)) {
        return particulars?.map((item, index) => ({
            value: item?.particular_id?.toString(),
            label: item?.particular_id + ". " + item?.particular_name,
            assets_dep_pers: item?.assets_dep_pers,
            is_debit: item?.is_debit,
        }));
    } else {
        return [];
    }
};

export const ParticularAssetsItemsOptions = (particulars) => {
    if (particulars && Array?.isArray(particulars)) {
        return particulars?.map((item, index) => ({
            value: item?.particular_id?.toString(),
            label: item?.particular_id + ". " + item?.particular_name,
            is_debit: item?.is_debit,
        }));
    } else {
        return [];
    }
};

export const DebitCreaditOptions = (debit_list) => {
    if (debit_list && Array.isArray(debit_list)) {
        return debit_list.map((item, index) => ({
            value: item.value.toString(),
            label: item.label
        }));
    } else {
        return [];
    }
};

export const FiscalYearOptions = (fiscal_year) => {
    if (fiscal_year && Array?.isArray(fiscal_year)) {
        return fiscal_year?.map((item, index) => ({
            value: item?.fiscal_year_id?.toString(),
            label: item?.fiscal_year_id + ". " + item?.fiscal_year_name,
            from_date_n: item?.from_date_n,
            to_date_n: item?.to_date_n,

        }));
    } else {
        return [];
    }
};

export const MasterCategoryOptions = (category) => {
    // Master Category Options
    if (category && Array?.isArray(category)) {
        return category?.map((cate, index) => ({
            value: cate?.product_master_id?.toString(),
            label: cate?.product_master_id + ". " + cate?.product_master_name,
        }));
    } else {
        return [];
    }
};

export const SubMasterOptions = (subMaster) => {
    if (subMaster && Array?.isArray(subMaster)) {
        return subMaster?.map((item, index) => ({
            value: item?.product_sub_master_id?.toString(),
            label: item?.product_sub_master_id + ". " + item?.product_sub_master_name,
        }));
    } else {
        return [];
    }
};

export const ItemUnitListOptions = (units) => {
    if (units && Array?.isArray(units)) {
        return units?.map((item, index) => ({
            value: item?.unit_id?.toString(),
            label: item?.unit_id + ". " + item?.short_name,
        }));
    } else {
        return [];
    }
};

export const StudentListOptions = (students) => {
    if (students && Array.isArray(students)) {
        return students.map((item, index) => ({
            value: item.member_sn.toString(),
            label: `${item?.member_sn}. ${item?.first_name} ${item?.middle_name ? item?.middle_name : ""} ${item?.last_name}`
        }));
    } else {
        return [];
    }
};

export const StudentSearchListOptions = (students) => {
    if (students && Array.isArray(students)) {
        return students?.map((item, index) => ({
            value: item?.member_sn?.toString(),
            label: `${item?.member_sn}. ${item?.first_name} ${item?.middle_name ? item?.middle_name : ""} ${item?.last_name}(${item?.phone})`,
            name: `${item?.first_name} ${item?.middle_name ? item?.middle_name : ""} ${item?.last_name}`

        }));
    } else {
        return [];
    }
};

export const ACStudentSearchListOptions = (students) => {
    if (students && Array.isArray(students)) {
        return students?.map((item, index) => ({
            value: item?.member_sn?.toString(),
            label: `${item?.member_sn}. ${item?.first_name} ${item?.middle_name ? item?.middle_name : ""} ${item?.last_name} ${parseInt(item?.bus_facility) === (1 || 2) ? ` | Van: ${parseInt(item?.bus_facility) === 1 ? `${item?.way} ${item?.destination_name} (Rs ${item?.destination_amount})` : parseInt(item?.bus_facility) === 2 ? item?.destination_name + " Cancel" : ""}` : ""} | Phone No.: ${item?.phone} ${item?.old_van ? `| OLD VAN: ${item?.old_van}` : ""}`,
            name: `${item?.first_name} ${item?.middle_name ? item?.middle_name : ""} ${item?.last_name}`,
            library_fine_amt: item?.library_fine_amt
        }));
    } else {
        return [];
    }
};

export const ProductOptionsListOptions = (products) => {
    if (products && Array?.isArray(products)) {
        return products?.map((product, index) => ({
            value: product?.product?.product_id,
            label: `${product?.product?.product_id + ". " + product?.product?.product_name}`,
            price: product?.product?.purchase_rate,
            available: product?.available_quantity
        }));
    } else {
        return [];
    }
};

export const ProductSuppilerOptions = (suppiler) => {
    // General Ledger Options
    if (suppiler && Array?.isArray(suppiler)) {
        return suppiler?.map((item, index) => ({
            value: item?.sup_id?.toString(),
            label: `${index + 1 + ". " + item?.sup_name}`,
        }));
    } else {
        return [];
    }
};

export const ProductStoreOptions = (store) => {
    if (store && Array?.isArray(store)) {
        return store?.map((item, index) => ({
            value: item?.store_id?.toString(),
            label: `${item?.store_id + ". " + item?.store_name}`,
        }));
    } else {
        return [];
    }
};

export const PurchaseStatusOptions = (items) => {

    if (items && Array.isArray(items)) {
        return items.map((item, index) => ({
            value: item.value.toString(),
            label: item.label
        }));
    } else {
        return [];
    }
};

export const ProductSellingOptionsListOptions = (products) => {

    if (products && Array?.isArray(products)) {
        return products?.map((item, index) => ({
            value: item?.product?.product_id,
            label: `${item?.product?.product_id + ". " + item?.product?.product_name}`,
            price: item?.product?.sales_rate,
            available: item?.available_quantity
        }));
    } else {
        return [];
    }
};

export const StockReportOptions = [
    { value: "0", label: "Total Purchase Report" },
    { value: "1", label: "Total Sales Report" },
    { value: "2", label: "Total Issue Report" },
    { value: "3", label: "Total Available Report" },
];

export const BookAuthorOptions = (items) => {
    if (items && Array.isArray(items)) {
        return items?.map((item, index) => ({
            value: item?.author_id?.toString(),
            label: item?.author_id + (". ") + item?.author_name
        }));
    } else {
        return [];
    }
};

export const BookPublicationOptions = (items) => {
    if (items && Array.isArray(items)) {
        return items.map((item, index) => ({
            value: item?.pub_id?.toString(),
            label: (item?.pub_id + (". ") + item?.pub_name)
        }));
    } else {
        return [];
    }
};

export const BookCategoryOptions = (items) => {
    if (items && Array.isArray(items)) {
        return items.map((item, index) => ({
            value: item?.sn?.toString(),
            label: item?.sn + (". ") + item?.book_cate_name
        }));
    } else {
        return [];
    }
};

export const StudentProfileOptions = (items) => {
    if (items && Array.isArray(items)) {
        return items.map((item, index) => ({
            value: item?.sn?.toString(),
            label: item?.sn + (". ") + item?.profile_name
        }));
    } else {
        return [];
    }
};

export const BookKindOptions = (items) => {
    if (items && Array.isArray(items)) {
        return items.map((item, index) => ({
            value: item.value?.toString(),
            label: item.label
        }));
    } else {
        return [];
    }
};

export const BookTypeOptions = (items) => {
    if (items && Array.isArray(items)) {
        return items.map((item, index) => ({
            value: item.value?.toString(),
            label: item.label
        }));
    } else {
        return [];
    }
};

export const IssuedForOptions = (items) => {
    if (items && Array.isArray(items)) {
        return items.map((item, index) => ({
            value: item.value?.toString(),
            label: item.label
        }));
    } else {
        return [];
    }
};

export const TirekoNatirekoOptions = [
    { value: "0", label: "All" },
    { value: "1", label: "Paid" },
    { value: "2", label: "Unpaid" },
];

export const CashBankOptions = [
    { value: "0", label: "Cash" },
    { value: "1", label: "Bank" },
    { value: "2", label: "Payable" },
    { value: "3", label: "Receivable" },
];

export const DuesCashBankOptions = [
    { value: "0", label: "Cash" },
    { value: "1", label: "Bank" },
];

export const PartFullTimeOptions = [
    { value: "1", label: "Part Time" },
    { value: "2", label: "Full Time" },
];

export const TeachNoTeachOptions = [
    { value: "1", label: "Teachning" },
    { value: "2", label: "Non Teaching Staff" },
];

export const StaffTypeOptions = [
    { value: "1", label: "Permanent" },
    { value: "2", label: "Temporary" },
    { value: "3", label: "Contract" },
    { value: "4", label: "Part Time" },
];
